import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.items = this.$('item')
  }

  init() {
    this.reveal()
  }

  reveal() {
    gsap.set(this.items, { autoAlpha: 0, y: 100 })

    ScrollTrigger.batch(this.items, {
      start: 'top 70%',
      onEnter: (batch) => {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          stagger: 0.1,
        })
      },
    })
  }
}
